import { OAuthEntryPoint } from '../../../components/OAuthEntryPoint';

export const EntryPoint = () => {
  return <OAuthEntryPoint />;
};
